export const SYMBOLS: { [key: string]: any } = {
  '1001': null,

  '1002': 'r',

  '1003': 'e',

  '1004': 'w',

  '1005': 'q',

  '1006': null,

  '1007': '0',

  '1008': null,

  '1009': null,

  '1010': null,

  '1011': null,

  '1012': 5,

  '1014': null,

  '1050': null,

  '1051': null,

  '2001': 'I',

  '2002': null,

  '2003': null,

  '3001': 'n',

  '3002': 'b',

  '3003': null,

  '4001': 'a',

  '4002': ']',

  '4003': null,

  '4004': null,

  '5001': 'j',

  '5002': null,

  '5003': 'd',

  '5004': null,

  '5005': null,

  '5006': null,

  '5007': 'l',

  '5008': null,

  '5009': null,

  '6060': 'M',

  '6061': 'X',

  '6062': null,

  '6063': null,

  '6064': null,

  '6065': 'C',

  '6066': 'X ?',

  '6067': 'D',

  '6068': null,

  '6069': 'M',

  '6070': null,

  '6071': null,

  '7071': null,

  '7072': null,

  '7073': null,

  '7074': null
};
